//src/Components/ProgressBar/index.tsx
import useMediaQueries from 'app/hooks/useMediaQueries';
import { useEffect, useRef, useState } from 'react';

export enum ProgressStatus {
  submitted = 'submitted',
  InProgress = 'In Progress',
  UnderReview = 'Under Review',
  ClientReview = 'Client Review',
  EFile = 'E-File',
  Accepted = 'Accepted',
  NotStarted = 'Not Started',
  Completed = 'Completed',
  MeetingScheduled = 'Meeting Scheduled',
  SentDept = 'Sent Dept.',
  Todo = 'Todo',
  Done = 'Done',
  InternalReview = 'Internal Review',
  Filed = 'Filed',
}

export const TaxReturnStatuses = [
  ProgressStatus.submitted,
  ProgressStatus.InProgress,
  ProgressStatus.InternalReview,
  ProgressStatus.ClientReview,
  ProgressStatus.Filed,
  ProgressStatus.Accepted,
];

export const TaskStatuses: ProgressStatus[] = [
  ProgressStatus.submitted,
  ProgressStatus.InProgress,
  ProgressStatus.InternalReview,
  ProgressStatus.Completed,
];

export interface IProgressBarProps {
  progressColor?: string;
  status?: string;
  labelPosition?: 'top' | 'bottom';
  className?: string;
  statuses?: string[];
}

function StatusLabels({ statuses }: { statuses: string[] }) {
  return (
    <div
      className="w-full shrink-0 flex justify-between py-2 md-max:hidden "
      style={{
        fontSize: `10px`,
      }}
    >
      {statuses.map((status, index) => (
        <div>{status}</div>
      ))}
    </div>
  );
}
export default function ProgressBar({
  className,
  progressColor = 'transparent linear-gradient(270deg, #39BE9D 0%, #96C93D 100%) 0% 0% no-repeat padding-box',
  status,
  statuses = [],
}: IProgressBarProps) {
  const [progressBarWidth, setProgressBarWidth] = useState<number>(0);

  const ref = useRef<HTMLDivElement>(null);
  const pgbarParentRef = useRef<HTMLDivElement>(null);

  const updateProgressBarWidth = () => {
    if (!ref.current || !pgbarParentRef.current) return;

    setProgressBarWidth(ref.current.offsetLeft + ref.current.clientWidth);
  };

  useEffect(updateProgressBarWidth, [ref.current, pgbarParentRef.current]);

  useEffect(() => {
    window.addEventListener('resize', updateProgressBarWidth, false);
    return () => window.removeEventListener('resize', updateProgressBarWidth);
  }, []);

  const { md_down: isMobile } = useMediaQueries();

  return (
    <div className={`${className}`}>
      <div className="hidden md-max:block text-gray-dark text-xs capitalize p-1 md-max:font-semibold">
        {status}
      </div>

      <div
        className="relative mb-2 grid justify-between items-end gap-1 md-max:gap-0 grid-flow-col md-max:py-0 md-max:invisible md-max:h-0"
        style={{
          fontSize: `10px`,
        }}
      >
        {statuses.map((_status, index) => (
          <div
            ref={_status === status ? ref : undefined}
            key={_status}
            className="grid whitespace-nowrap justify-center items-center text-center odd:text-gray-700 even:text-gray-dark capitalize"
          >
            {isMobile ? 'xxx' : _status}
          </div>
        ))}
      </div>

      {/* Progress Bar */}
      <div
        ref={pgbarParentRef}
        className="bg-gray-800 w-full relative h-2.5 rounded-full"
      >
        <div
          className="rounded-full h-full absolute"
          style={{
            width: `${progressBarWidth}px`,
            background: `${progressColor}`,
          }}
        />
      </div>
      {TaxReturnStatuses.includes(status as ProgressStatus) &&
        status === ProgressStatus.ClientReview && (
          <div className="mt-2 flex justify-center">
            <div className="px-2 bg-orange-light text-orange-dark text-sm font-semibold rounded-md flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4m0 4h.01M9 21h6a2 2 0 002-2v-4.35a4.992 4.992 0 00-1.722-3.766A4.992 4.992 0 0015 7V5a3 3 0 00-6 0v2a4.992 4.992 0 00-1.278 3.884A4.992 4.992 0 006 14.65V19a2 2 0 002 2z"
                />
              </svg>
              Note: Ignore this message if the invoice appears 'Paid'. If not,
              please proceed with payment.
            </div>
          </div>
        )}
    </div>
  );
}
